module.exports = __webpack_public_path__ + "../../../static/img/c_im_30.af216076.png";